"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RedirectButton_meta_1 = require("../RedirectButton.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', RedirectButton_meta_1.REDIRECT_BUTTON_CATEGORY_KEY, RedirectButton_meta_1.REDIRECT_BUTTON_COMPONENT_KEY, ['wrapper']);